import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { ErrorSummary } from "@career/core/models/error.model";
import { PortalService } from "@career/core/services/portal.service";
import { ACTIVE_LAYER_CONFIG, LayerConfig, LayerOverlayRef } from "kleos-ui";
import { Subscription } from "rxjs";

@Component({
  selector: "app-edit-video-dialog",
  templateUrl: "./edit-video-dialog.component.html",
  styleUrls: ["./edit-video-dialog.component.scss"],
})
export class EditVideoDialogComponent implements OnInit, OnDestroy {
  videoUrl: string = "";
  name: string = "";
  error: ErrorSummary;
  subs: Subscription[] = [];

  constructor(
    private portalService: PortalService,
    private layerRef: LayerOverlayRef,
    @Inject(ACTIVE_LAYER_CONFIG) public config: LayerConfig
  ) {}

  ngOnInit(): void {
    this.videoUrl = this.config.data.currentUrl || "";
    this.name = this.config.data.name || "Video";
  }

  onSave(): void {
    const sub = this.portalService
      .patchComponent(
        { assets: { video: this.videoUrl } },
        this.config.data.component
      )
      .subscribe(
        () => {
          this.error = null;
          this.layerRef.close();
        },
        (error) => {
          this.error = new ErrorSummary(
            error.message || "Unknown",
            error.status || "unknown"
          );
        }
      );
    this.subs.push(sub);
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
